import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { BaseService } from "../shared/services/base.service";


@Injectable({
  providedIn: 'root'
})
export class FaqService {

  public faqList = new BehaviorSubject({});
  faqList$ = this.faqList.asObservable();
  defaultFields = '?fields=DEFAULT';


  constructor(
    public readonly baseService: BaseService,
  ) { }

  getFAQ() {
    this.baseService.get('frequently-asked-questions'+ this.defaultFields).subscribe((res) => {
      if (res) {
        this.faqList.next(res);
      }
    });
  }

}
